import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import theme from 'theme'

export const ResetWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: sticky;
  bottom: 0;
  background: ${theme.colors.borderMedium};
  padding: ${theme.spacing.xSmall}px ${theme.spacing.medium}px ${theme.spacing.small}px;

  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
  }

  .reset-button {
    border-radius: ${theme.attributes.borderRadius.large};
    cursor: pointer;
    color: ${theme.colors.cta};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    text-transform: none;
    width: fit-content !important;
    height: 40px;
    background: transparent;

    &:hover {
      background: rgba(234, 221, 255, 0.08);
    }

    &.Mui-disabled {
      background: ${theme.colors.btnTertiaryBg} !important;
      opacity: 1;
      color: ${theme.colors.mutedMauve};
      text-align: center;
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.thin};
      line-height: normal;
    }
  }
`
